import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=040e2bfd&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e2bfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('040e2bfd')) {
      api.createRecord('040e2bfd', component.options)
    } else {
      api.reload('040e2bfd', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=040e2bfd&scoped=true&", function () {
      api.rerender('040e2bfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26umCrTn3XRce/JS/comp/Accordion.vue"
export default component.exports